export type NoticeProps = {
  error?: string | null | undefined;
  success?: string | null | undefined;
  warning?: string | null | undefined;
  info?: string | null | undefined;
};

/**
 * Mensagens de feedback. Erros usam `role="alert"` (anúncio imediato);
 * sucesso, aviso e informação usam `role="status"` (anúncio educado).
 * Não renderiza nada quando todas as mensagens estão vazias.
 */
export function Notice({ error, success, warning, info }: NoticeProps) {
  if (!error && !success && !warning && !info) return null;
  return (
    <>
      {error && (
        <p role="alert" className="notice error">
          {error}
        </p>
      )}
      {warning && (
        <p role="status" className="notice warning">
          {warning}
        </p>
      )}
      {success && (
        <p role="status" className="notice success">
          {success}
        </p>
      )}
      {info && (
        <p role="status" className="notice info">
          {info}
        </p>
      )}
    </>
  );
}
